// extracted by mini-css-extract-plugin
export default {"FooterWrapper":"Footer_FooterWrapper__z35rR","LowerBrand":"Footer_LowerBrand__ECzI7","Links":"Footer_Links__DDAo4"};